import { ColumnType } from '@bettercomp/ui-components';
import { ConfigItem } from '@bettercomp/ui-components';

export const filterConfig = (config: ColumnType[]) => {
  return config.reduce((filteredConfig: ColumnType[], group) => {
    if (!group.children) {
      if (group.enabled !== false) {
        return [...filteredConfig, group];
      }
      return filteredConfig;
    }
    if (!group.children.some(column => column.enabled !== false)) {
      return filteredConfig;
    }
    return [
      ...filteredConfig,
      {
        ...group,
        children: group.children.filter(column => column.enabled !== false),
      },
    ];
  }, []);
};

type ExportColumnType = { type?: string, key?: string, title?: string, fractionDigits?: number };

export const filterConfigForExport = (config: ColumnType[]) => {
  return config.reduce((filteredConfig: ExportColumnType[], group) => {
    if (group.children) {
      return [
        ...filteredConfig,
        ...group.children.filter(column => column.enabled !== false).map(column => ({
          key: column.key as string,
          type: column.type,
          fractionDigits: column.onCell ? (column.onCell({}) as any)?.payload?.fractionDigits : undefined,
          title: column.exportTitle
            ? column.exportTitle
            : group.title
              ? `${group.title} - ${column.title}`
              : column.title as string,
        })),
      ];
    }

    if (!group.key) {
      return filteredConfig;
    }

    if (group.enabled !== false) {
      return [...filteredConfig, {
        key: group.key as string,
        title: group.title as string,
        type: group.type,
        fractionDigits: group.onCell ? (group.onCell({}) as any)?.payload?.fractionDigits : undefined,
      }];
    }

    return filteredConfig;
  }, []);
};

export const mapTableConfigToEditConfig = (tableConfig: ColumnType[]): ConfigItem[] => tableConfig.map((item) => ({
  key: item.key,
  title: item.editTitle || (typeof item.title === 'string' ? item.title : ''),
  configurable: item.configurable,
  children: item.children?.map((child) => ({
    key: child.key,
    title: child.editTitle || (typeof child.title === 'string' ? child.title : ''),
    configurable: child.configurable,
  }))
}));
